import React from 'react'
import { Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import TextInput from 'components/ui/forms/field/text-input/TextInput'
import RichTextInput from 'components/ui/forms/field/rich-text-input/RichTextInput'
import InputLabel from 'components/ui/forms/field/input-label/InputLabel'
import styles from './EmailForm.module.scss'

interface IProps {
  emailSubject: string
  setSubject: React.Dispatch<React.SetStateAction<string>>
  emailBody: string
  setEmailBody: React.Dispatch<React.SetStateAction<string>>
}

const EmailForm: React.FC<IProps> = ({
  emailSubject,
  setSubject,
  emailBody,
  setEmailBody,
}) => {
  const { t } = useTranslation()

  const joditConfig = {
    buttons: 'bold,italic,underline,link',
  }

  return (
    <>
      <Form.Group>
        <InputLabel
          className={styles.typeLabel}
          label={t('administration.monitor.sendEmail.form.subject')}
        />
        <TextInput
          name="subject"
          value={emailSubject}
          onChange={(e) => setSubject(e.target.value)}
        />
      </Form.Group>
      <Form.Group>
        <InputLabel
          className={styles.typeLabel}
          label={t('administration.monitor.sendEmail.form.content')}
        />
        <RichTextInput
          name="content"
          value={emailBody}
          onChange={(value) => setEmailBody(value)}
          config={joditConfig}
        />
      </Form.Group>
    </>
  )
}

export default EmailForm
